export enum UserModesEnum {
    ORG_LEVEL = 0,
    NERWORK_LEVEL = 1
}